import React, { useEffect, useState } from "react";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { StudyProgram } from "@bindeleddet/core/types";
import axios from "axios";
import { faUserPen } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import { Skeleton } from "antd";
import ProfileCardBase from "./ProfileCardBase/ProfileCardBase";

const { Button: SkeletonButton } = Skeleton;

const PersonalCard: React.FC = () => {
  const { currentUser } = useLoginContext();
  const [studyProgram, setStudyProgram] = useState<StudyProgram>();

  useEffect(() => {
    if (isCompanyUser(currentUser) || !currentUser) return;
    axios
      .get<StudyProgram>(`/students/study-program/${currentUser?.study_programme}/`)
      .then(response => setStudyProgram(response.data));
  }, [currentUser]);

  if (isCompanyUser(currentUser) || !currentUser) return null;

  return (
    <ProfileCardBase
      title="Personlig Informasjon"
      actionText="Rediger"
      actionLink="/student-profile/edit-profile/"
      icon={faUserPen} // Pass the FontAwesome icon directly
    >
      {currentUser.first_name} {currentUser.last_name}
      <br />
      {currentUser.year_level}. klasse -{" "}
      {studyProgram?.name ?? <SkeletonButton style={{ height: "20px", width: "100px" }} />}
      <br />
    </ProfileCardBase>
  );
};

export default PersonalCard;
